import React from 'react'
import { useAccountSecurityContext } from 'providers'
import SessionDismissible from 'session-dismissible'
import MFA from './MFA'
import { useRemindAccountSecurity } from '../utils'
import PasswordExpiry from './PasswordExpiry'

const MFAPopupStorageKey = 'remindMFAPopup-closed'
const PasswordPopupStorageKey = 'remindPasswordPopup-closed'

/**
 *
 */
const Index = () => {
    const { passwordSecurityState } = useAccountSecurityContext()
    const { remindMFA, remindPasswordExpiry } = useRemindAccountSecurity()

    const wasMFAPopupDismissed = sessionStorage.getItem(MFAPopupStorageKey) === 'true'

    if (remindMFA && !wasMFAPopupDismissed) return <SessionDismissible storageKey={MFAPopupStorageKey}><MFA /></SessionDismissible>

    if (remindPasswordExpiry && !passwordSecurityState.data.passwordExpiryDialogShown) {
        return (
            <SessionDismissible storageKey={PasswordPopupStorageKey}>
                <PasswordExpiry hasExpired={false} date={passwordSecurityState.data.passwordExpiryDate!} />
            </SessionDismissible>
        )
    }

    return null
}

export default Index
